//@ts-nocheck
import { TransactionTypeFilter } from "@/store/modules/transactions"

export default {
	methods: {
		onChange(e: Event) {
			this.currentFilter = e.target.value;
		},
	},
	computed: {
		currentFilter: {
			get: function() {
				return this.$store.state.transactions.transactionsTypeFilter;
			},
			set: function(newValue) {
				this.$store.state.transactions.transactionsTypeFilter = newValue;
			},
		},
	},
	render: function(h) {
		return (
			<div class="transactions-type-picker">
				<select class="btn btn-sm" onChange={this.onChange} value={this.currentFilter}>
					<option value={TransactionTypeFilter.ALL}>Všetky</option>
					<option value={TransactionTypeFilter.CREDIT}>Kredity</option>
					<option value={TransactionTypeFilter.DEBIT}>Debety</option>
				</select>
			</div>
		);
	},
};
